import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCloseLink = styled.a.withConfig({
  displayName: "CloseButton__StyledCloseLink",
  componentId: "fyhr3f-0"
})(["margin-inline:", " !important;"], ({
  theme
}) => theme.space[300]);
export const CloseSearchButton = ({
  children
}) => {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledCloseLink, {
      href: "#",
      color: "icon-core-subtle",
      children: children
    })
  );
};